import { z } from "zod";

/**
 * What the "Track this trade" link on a signal carries to /trades: the
 * signal's own plan, so the form opens filled in.
 *
 * Every field degrades to absent rather than failing the navigation. A link
 * with a bad number should still open the page, with that box empty.
 */
const loose = <T extends z.ZodTypeAny>(schema: T) => schema.optional().catch(undefined);

export const tradesSearchSchema = z
  .object({
    symbol: loose(z.string()),
    side: loose(z.enum(["long", "short"])),
    entry: loose(z.coerce.number().positive()),
    stop: loose(z.coerce.number().positive()),
    target: loose(z.coerce.number().positive()),
    signalId: loose(z.string().uuid()),
  })
  .strip();

export type TradesSearch = z.infer<typeof tradesSearchSchema>;
